export default __webpack_public_path__ + "2c10f5d6bba1b640267bfb3ea8a25d12.svg";